import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class CreateCertificationDto {
  @Expose()
  dossierId: string;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : undefined))
  @Expose()
  startDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : undefined))
  @Expose()
  endDate?: Date;
}
